import { shade, tint } from 'polished';
import React from 'react';
import styled from 'styled-components';
import { Images } from '../../../@resources/img';
import { Point } from '../../../platform/geom/Point';
import { CardPack } from '../../packages/hand/CardPack';
import { Colors } from './../../../ui';
import { aspect } from './Aspect';
import { RenderBorder, RenderBounds } from './RenderHelpers';
import { VisualBase } from './VisualBase';

/* eslint-disable max-len */
/* eslint-disable no-mixed-operators */
export class CardPackVisual extends VisualBase<CardPack> {

    @aspect()
    private get isHover() {
        const { interaction, isPressed } = this;
        return interaction?.type === 'invoke' && !isPressed;
    }

    @aspect()
    private get isActive() {
        const { interaction, isPressed } = this;
        return interaction?.type === 'invoke' && isPressed;
    }

    @aspect()
    private get shadow() {
        // Compute shadow angle for rotation
        const pt = new Point(0, 3).rotate(this.object.r * -1);
        return `
            ${pt.x}px ${pt.y}px 10px 0 rgba(0, 0, 0, 0.1),
            0 4px 0 0 ${Colors.primaryText}
        `;
    }

    @aspect()
    private get borderStyling(): any {
        const { object } = this;
        const { isHover, isActive } = this;
        const fill = (isHover || isActive) ? shade(isActive ? 0.2 : 0.1, Colors.primary) : tint(.15, Colors.primary);
        return {
            position: 'relative',
            width: object.width,
            height: object.height - 4,
            backgroundColor: fill,
            borderRadius: '4px',
            border: `solid 4px ${Colors.primary}`,
            boxShadow: this.shadow,
            overflow: 'hidden',
        };
    }

    // private get highlightStyling(): any {
    //     const { pose } = this;
    //     const { autoColor, background } = this.object;
    //     const blend = (pose.selected) ? 0 : 0.5;
    //     return {
    //         borderColor: tint(blend, autoColor || background),
    //     };
    // }

    public render() {
        return <RenderBounds object={this.object}>
            <RenderBorder pose={this.pose} style={this.borderStyling}>
                <RenderLogo />
            </RenderBorder>
        </RenderBounds>;
    }
}

const RenderLogo = styled.div`
    position: absolute;
    left: 50%;
    top: 50%;
    width: 48px;
    height: 48px;
    transform: translate(-50%,-50%);
    border-radius: 4px;
    background-image: url(${Images.LogoWhite});
`;
